import React, { useEffect, useState } from 'react';
import './styles.css';

function Index() {
  const [speedMbps, setSpeedMbps] = useState(null);
  const [status, setStatus] = useState('Desconocido');
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  const testConnectionSpeed = async () => {
    if (!navigator.onLine) {
      setIsOnline(false);
      setStatus('Sin conexión');
      setSpeedMbps(null);
      return;
    }

    const image = new Image();
    const imageSizeInBytes = 500000; // 500 KB

    const startTime = performance.now();
    image.src = `https://upload.wikimedia.org/wikipedia/commons/3/3f/Fronalpstock_big.jpg?${Math.random()}`;
    
    image.onload = () => {
      const endTime = performance.now();
      const durationInSeconds = (endTime - startTime) / 1000;
      const bitsLoaded = imageSizeInBytes * 8;
      const mbps = (bitsLoaded / durationInSeconds / 1024 / 1024).toFixed(2);
      setSpeedMbps(mbps);
      setIsOnline(true);

      const mbpsNum = parseFloat(mbps);
      if (mbpsNum > 5) setStatus('Buena');
      else if (mbpsNum > 1) setStatus('Regular');
      else setStatus('Mala');
    };

    image.onerror = () => {
      setIsOnline(false);
      setSpeedMbps(null);
      setStatus('Sin conexión');
    };
  };

  useEffect(() => {
    testConnectionSpeed();
    const interval = setInterval(testConnectionSpeed, 5000);

    const handleOnline = () => {
      setIsOnline(true);
      testConnectionSpeed();
    };

    const handleOffline = () => {
      setIsOnline(false);
      setStatus('Sin conexión');
      setSpeedMbps(null);
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      clearInterval(interval);
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  const getColor = () => {
    if (!isOnline || status === 'Sin conexión') return 'red';
    if (status === 'Buena') return 'limegreen';
    if (status === 'Regular') return 'orange';
    if (status === 'Mala') return 'red';
    return 'gray';
  };

  return (
    <div
      style={{
        backgroundSize: 'cover',
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'black',
        flexDirection: 'column',
        position: 'relative'
      }}
    >
      <img
         onClick={() => window.location.reload()}
        className={'logo'}
        src={require('./assets/logo.png')}
        alt="Logo"
      />

      {/* Indicador de conexión */}
      <div  onClick={() => window.location.reload()} style={{
        position: 'absolute',
        top: 10,
        right: 10,
        backgroundColor: '#222',
        padding: '8px 12px',
        borderRadius: 8,
        color: getColor(),
        fontWeight: 'bold',
        zIndex: 10,
      }}>
        {isOnline ? (
          speedMbps ? (
            <>📶 {speedMbps} Mbps - {status}</>
          ) : (
            <>🔄 Midiendo velocidad...</>
          )
        ) : (
          <>❌ Sin conexión</>
        )}
      </div>

      {/* Footer */}
      <div
        onClick={() => window.location.reload()}
        style={{
          position: 'absolute',
          bottom: 0,
          textAlign: 'center',
          backgroundColor: 'black',
          width: '100%'
        }}>
        <p style={{ color: 'white' }}>Powered by boostyourmenu.com V1.2</p>
      </div>
    </div>
  );
}

export default Index;
